import {
  faChartLine,
  faFileImage,
  faInfo,
  faLifeRing,
  faListAlt,
  faTachometer,
  faTasks,
  faTasksAlt,
  faUsers,
} from '@fortawesome/pro-light-svg-icons'

type GenerateMainNavigationItemsParams = {
  isTeamLead: boolean,
  teamsWhereTeamLeadIds: number[],
  canvaTemplatesEnabled: boolean,
  isAdmin?: boolean
  isBrandUser?: boolean
  isProviderDirector?: boolean
}

const generateMainNavigationItems = (params: GenerateMainNavigationItemsParams) => {
  const {
    canvaTemplatesEnabled,
    isAdmin,
    isBrandUser,
    isProviderDirector,
    isTeamLead,
    teamsWhereTeamLeadIds,
  } = params

  return {
    sections: [
      {
        key: 'dashboard',
        visible: true,
        items: [
          {
            href: '#/',
            icon: faTachometer,
            key: 'dashboard',
            title: 'Overview',
            visible: true,
          },
        ],
      },
      {
        key: 'projects',
        title: 'Projects',
        visible: true,
        items: [
          {
            href: '#/analytics',
            icon: faChartLine,
            key: 'analytics',
            title: 'Analytics',
            visible: true,
          },
          {
            href: `#/tasks/teamOverview?team_id=${teamsWhereTeamLeadIds[0]}`,
            icon: faUsers,
            key: 'team',
            title: 'Team',
            visible: isTeamLead,
          },
          {
            href: '#/projects?adHoc=false',
            icon: faTasksAlt,
            key: 'projects',
            title: 'Projects',
            visible: true,
          },
          {
            href: '#/tasks?sub_tasks=false',
            icon: faTasks,
            key: 'tasks',
            title: 'Tasks',
            visible: true,
          },
          {
            href: '#/tasks?sub_tasks=true',
            icon: faTasks,
            key: 'subTasks',
            title: 'Sub Tasks',
            visible: true,
          },
          {
            href: '#/qualityControl/taskListTemplates',
            icon: faListAlt,
            key: 'checklists',
            title: 'Checklists',
            visible: true,
          },
        ],
      },
      {
        key: 'templates',
        title: 'Templates',
        visible: true,
        items: [
          {
            href: '#/templatePages?hidden=false',
            icon: faFileImage,
            key: 'templatePages',
            title: 'Templates',
            visible: true,
          },
          {
            href: '#/canvaTemplates?hidden=false',
            icon: faFileImage,
            key: 'canvaTemplates',
            title: 'Canva Templates',
            visible: canvaTemplatesEnabled,
          },
          {
            href: '#/templatePagePartials?hidden=false',
            icon: faFileImage,
            key: 'templatePagePartials',
            title: 'Icons & Partials',
            visible: true,
          },
          {
            href: '#/layoutTemplates?hidden=false',
            icon: faFileImage,
            key: 'layoutTemplates',
            title: 'Layouts',
            visible: true,
          },
        ],
      },
      {
        key: 'support',
        title: 'Support',
        visible: isAdmin || isBrandUser || isProviderDirector,
        items: [
          {
            href: 'https://intercom.help/realhub/en',
            icon: faLifeRing,
            key: 'training',
            linkProps: {
            target: '_blank',
            },
            title: 'Training',
            visible: true,
          },
          {
            href: 'https://intercom.news/realhub_updates',
            icon: faInfo,
            key: 'product-news',
            linkProps: {
              target: '_blank',
            },
            title: 'Product News',
            visible: true,
          },
        ],
      }
    ],
  }
}

export default generateMainNavigationItems
